<div class="content">
    <div class="visual" showleft [showDelay]="50">
        <img ngSrc="/images/home/veyora-fit-details.webp" fill
            alt="Veyora Fit activewear fabric texture, seams, and waistband details">
    </div>
    <div class="copy">
        <p class="eyebrow">Why it feels different</p>
        <h2>Details you feel before anyone sees them.</h2>
        <div class="items">
            <div class="item" showleft [showDelay]="100">
                <mat-icon fontSet="material-symbols-outlined">body_system</mat-icon>
                <div class="texts">
                    <h4>Stay-put support</h4>
                    <p>Waistbands and seams sit smooth through bends, lifts, and long walks.</p>
                </div>
            </div>
            <div class="item" showleft [showDelay]="180">
                <mat-icon fontSet="material-symbols-outlined">air</mat-icon>
                <div class="texts">
                    <h4>Soft, breathable stretch</h4>
                    <p>Brushed performance fabrics feel easy on training days and gentle on recovery days.</p>
                </div>
            </div>
            <div class="item" showleft [showDelay]="260">
                <mat-icon fontSet="material-symbols-outlined">layers</mat-icon>
                <div class="texts">
                    <h4>Made to layer</h4>
                    <p>Clean silhouettes that pair naturally with bras, tanks, jackets, and off-duty staples.</p>
                </div>
            </div>
        </div>
    </div>
</div>
